import { useRef } from "react";
import useListFilters from "../../hooks/useListFilters";
import { useAdminInvites } from "../../http/serviceportalApi";
import { useTranslations } from "../../hooks/useTranslations";
import { formatLongDateTime, getRemoteDataStatus } from "../../utils";
import Page from "../ui/Page";
import Table from "../ui/Table";
import InviteStatus from "./InviteStatus";

const AdminInvites = () => {
  const { i18n } = useTranslations();
  const filters = useListFilters();
  const aborter = useRef(new AbortController());
  const { data, isValidating, error } = useAdminInvites(
    filters.state,
    aborter.current.signal,
  );
  const items = data?.items ?? [];
  const hasNextPage = data?.next_page !== undefined;
  const status = getRemoteDataStatus({ isValidating, error });

  return (
    <Page title={i18n.admin.invites.title}>
      <Table
        filters={filters}
        head={
          <tr>
            <th align="left">{i18n.admin.invites.columnHeaders.email}</th>
            <th align="left">{i18n.admin.invites.columnHeaders.member}</th>
            <th align="left">{i18n.admin.invites.columnHeaders.companies}</th>
            <th align="left">{i18n.admin.invites.columnHeaders.validUntil}</th>
            <th align="left">{i18n.admin.invites.columnHeaders.status}</th>
          </tr>
        }
        body={items.map((invite, index) => (
          <tr key={index}>
            <td>{invite.email}</td>
            <td>{invite.memberName}</td>
            <td>{invite.companyId ? invite.companyName : i18n.allCompanies}</td>
            <td>{formatLongDateTime(invite.expiresAt)}</td>
            <td>
              <InviteStatus invite={invite} />
            </td>
          </tr>
        ))}
        hasNextPage={hasNextPage}
        remoteDataStatus={status}
      />
    </Page>
  );
};

export default AdminInvites;
